import React from 'react';
import { FallbackProps } from 'react-error-boundary';

import { isHttpError } from '../../../utils/network/http-error';
import NotFoundPage from '../error-pages/NotFoundPage/NotFoundPage';
import ServerErrorPage from '../error-pages/ServerErrorPage/ServerErrorPage';
import SomethingWentWrongPage from '../error-pages/SomethingWentWrongPage/SomethingWentWrongPage';
import AccessDenied from '../error-pages/access-denied/AccessDenied';

export default function ErrorFallback({
  error,
  resetErrorBoundary,
}: FallbackProps) {
  if (process.env.NODE_ENV === 'development') {
    console.error('Error caught by ErrorBoundary:', error);
  }

  if (isHttpError(error)) {
    const status = error.status;

    if (status === 404) {
      return <NotFoundPage />;
    }

    if (status === 403) {
      return <AccessDenied />;
    }

    return <ServerErrorPage />;
  }

  return <SomethingWentWrongPage />;
}
